'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
    function CookieWrapper(cookie) {
        _classCallCheck(this, CookieWrapper);

        this.cookie = cookie || (typeof document !== 'undefined' ? document.cookie : '');
        this.notifications = this._parseNotifications();
    }

    _createClass(CookieWrapper, [{
        key: 'removeNotifications',
        value: function removeNotifications() {
            var _this = this;

            this.notifications.forEach(function (notification) {
                _this.removeNotification(notification.id);
            });
        }
    }, {
        key: 'removeNotification',
        value: function removeNotification(id) {
            if (typeof document !== 'undefined') {
                document.cookie = id + '=; expires=Thu, 01-Jan-70 00:00:01 GMT; path=/; domain=' + document.domain + ';';
            }
        }

        /**
            "Private" Methods
         */

    }, {
        key: '_parseNotifications',
        value: function _parseNotifications() {
            return (this.cookie.match(this._getRegExp()) || []).map(this._parseNotification.bind(this)).filter(function (notification) {
                return typeof notification !== 'undefined';
            });
        }
    }, {
        key: '_parseNotification',
        value: function _parseNotification(notification) {
            var parsedNotification = this._getRegExp().exec(notification);
            try {
                return {
                    id: parsedNotification[1],
                    data: JSON.parse(Base64.decode(parsedNotification[2]))
                };
            } catch (e) {
                if (!process.env.NODE_ENV === 'test') {
                    console.error('Could not parse notification data', e);
                }
            }
        }
    }, {
        key: '_getRegExp',
        value: function _getRegExp() {
            return (/(notification\[\d+\])=([\w=\+\/]*)/g
            );
        }
    }]);

    return CookieWrapper;
}();


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/utils/cookie-wrapper.js
 ** module id = 714
 ** module chunks = 0 1
 **/